import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { MarketingAnalyticsAudienceGrowth } from "./marketing-analytics-audience-growth";

export const MarketingAnalyticsAudience = memo(
  function MarketingAnalyticsAudience({
    dateFilter,
  }: {
    dateFilter: [Temporal.PlainDate, Temporal.PlainDate] | undefined;
  }) {
    return (
      <Flex dir="column" gap="4xl" pb="8xl" w="full">
        <MarketingAnalyticsAudienceGrowth dateFilter={dateFilter} />
      </Flex>
    );
  },
);
